import hcAxios, { RequestOptions } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 币币优化
enum API {
  /** 计划委托下单 @admin */
  EntrustPlanOrderPlace = '/hk-web/entrust/plan/order/place',
  /** 是否关闭弹窗--存 @admin */
  PopupPutStatus = '/hk-web/popup/putStatus',
  /** 是否关闭弹窗--取 @admin */
  PopupGetStatus = '/hk-web/popup/getStatus',
  /** 查询coin信息 @undefined */
  CoinInfoList = '/hk-web/coinInfo/list',
  /** 交易页分页查询委托 @admin */
  EntrustTopList = '/hk-web/entrust/top/list',
  /** 根据委托id查询订单成交明细列表 @Frank */
  EntrustLogList = '/hk-web/entrust/log/list',
  /** 根据多条件查询订单成交明细列表 @Frank */
  EntrustTradeFills = '/hk-web/entrust/trade/fills',
  /** 根据多条件查询订单成交历史列表 @Frank */
  EntrustTradeHistory = '/hk-web/entrust/trade/history',
  /** 当前委托订单数量 @admin */
  EntrustOpenOrders = '/hk-web/entrust/open-orders',
  /** 计划委托下单 @admin */
  TestEntrustPlanOrderPlace = '/hk-web/test/entrust/plan/order/place',
  /** 查询币对币对提示事件 @Frank */
  PublicTradeTips = '/hk-web/public/trade/tips',
  /** 查询币对信息和标签信息-test @Frank */
  SymbolLabelInfoTest = '/hk-web/symbol_label/info_test',
  /** 全部订单分页查询委托 @admin */
  EntrustList = '/hk-web/entrust/list',
  /** 查询订单委托详情 @Frank */
  EntrustDetail = '/hk-web/entrust/detail',
  /** 查询币对信息 @admin */
  SymbolList = '/hk-web/symbol/list',
  /** 查询币对信息和标签信息 @admin */
  SymbolLabelInfo = '/hk-web/symbol_label/info',
  /** 查询标签信息 @admin */
  TradeLabelList = '/hk-web/trade_label/list',
}

export type TPostEntrustPlanOrderPlaceParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostEntrustPlanOrderPlaceResponse = TResponse<any>
export const postEntrustPlanOrderPlace = (params?: TPostEntrustPlanOrderPlaceParams) => {
  return hcAxios.post<TPostEntrustPlanOrderPlaceResponse>(API.EntrustPlanOrderPlace, params, {
    options: {
      signature: true,
    },
  })
}

export type TGetEntrustPlanOrderPlaceParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TGetEntrustPlanOrderPlaceResponse = TResponse<any>
export const getEntrustPlanOrderPlace = (params?: TGetEntrustPlanOrderPlaceParams, options?: RequestOptions) => {
  return hcAxios.get<TGetEntrustPlanOrderPlaceResponse>(API.EntrustPlanOrderPlace, { params, options })
}

export type TGetPopupPutStatusParams = any
export type TGetPopupPutStatusResponse = TResponse<number>
export const getPopupPutStatus = (params?: TGetPopupPutStatusParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPopupPutStatusResponse>(API.PopupPutStatus, { params, options })
}

export type TGetPopupGetStatusParams = any
export type TGetPopupGetStatusResponse = TResponse<{
  /** 计划委托弹窗 1开启 2关闭 */
  entrustStatus?: number
  /** 计划委托弹窗 1开启 2关闭 */
  etfStatus?: number
}>
export const getPopupGetStatus = (params?: TGetPopupGetStatusParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPopupGetStatusResponse>(API.PopupGetStatus, { params, options })
}

export type TGetCoinInfoListParams = {
  /** 币种名简称，如BTC，大小写均可 */
  coinShortName?: any
  /** 是否过滤ETF，true表示过滤ETF */
  filterEtf?: any
}
export type TGetCoinInfoListResponse = TResponse<
  {
    /** 预计到账时间(分钟) */
    arrivalTime?: number
    /** 计算精度 */
    calcPrecision?: number
    /** 链名称 */
    chainName?: string
    /** 币种id */
    coinId?: number
    /** 区块确认数量 */
    confirmations?: number
    /** 提现是否百分比收费 */
    isPercentage?: boolean
    /** 充值是否使用地址标签 */
    isUseMemo?: boolean
    /** 提现是否使用地址标签 */
    isWithdrawMemo?: boolean
    /** 币种中文名称 */
    nameEn?: string
    /** 币种英文名称 */
    nameZh?: string
    /** 网络名称 */
    networkName?: string
    /** 是否可以充币 */
    recharge?: boolean
    /** 最低充值数量 */
    rechargeMinLimit?: string
    /** 币种简称 */
    shortName?: string
    /** 子链 */
    subCoinList?: {}[]
    /** 交易精度 */
    tradePrecision?: number
    /** 是否可以划转 */
    transfer?: boolean
    /** webLogo */
    webLogo?: string
    /** 是否可以提现 */
    withdraw?: boolean
    /** 提现费用 */
    withdrawFee?: string
    /** 最小提现数量 */
    withdrawMin?: string
    /** 提现精度 */
    withdrawPrecision?: number
  }[]
>
export const getCoinInfoList = (params?: TGetCoinInfoListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCoinInfoListResponse>(API.CoinInfoList, { params, options })
}

export type TGetEntrustTopListParams = any
export type TGetEntrustTopListResponse = TResponse<any[]>
export const getEntrustTopList = (params?: TGetEntrustTopListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetEntrustTopListResponse>(API.EntrustTopList, { params, options })
}

export type TGetEntrustLogListParams = {
  /** 委单ID */
  entrustId?: any
  /** 委托类型（-1-限价|市价、0-限价委托、1-市价委托、4-计划委托、5跟踪委托 6高级限价、7只做Maker、8全部成交或立即取消、9立即成交并取消剩余），新版本必传 */
  matchType?: any
}
export type TGetEntrustLogListResponse = TResponse<
  {
    /** 交易额 */
    amount?: string
    /** 标的币，比如BTC */
    baseCurrency?: string
    /** 数量 */
    count?: string
    /** 创建时间 */
    createTime?: number
    /** 委单ID */
    entrustId?: number
    /** 委单类型 0-买单 1-卖单 */
    entrustType?: number
    /** 手续费 */
    fee?: string
    /** id */
    id?: number
    /** 更新时间 */
    lastupdattime?: number
    /** 成交ID */
    matchId?: number
    /** 撮合类型 0-限价、1-市价、4-计划委托、5跟踪委托 6高级限价、7只做Maker、8全部成交或立即取消、9立即成交并取消剩余 */
    matchType?: number
    /** 价格 */
    prize?: string
    /** 计价币，比如USDT */
    quoteCurrency?: string
    /**  备注 */
    remark?: string
    /** 成交角色 Maker Taker */
    role?: string
    /** 来源 */
    source?: number
    /** 交易区(1-GAVC区 2-BTC区 3-ETH区 4-USDT区 5-创新区 6-ETF交易区 7-USDC区 8-ALTS区 9-BUSD区) */
    tradeArea?: number
    /** 交易ID */
    tradeId?: number
    /** 用户ID */
    uid?: number
  }[]
>
export const getEntrustLogList = (params?: TGetEntrustLogListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetEntrustLogListResponse>(API.EntrustLogList, { params, options })
}

export type TGetEntrustTradeFillsParams = {
  /** 是否返回总记录数，默认true */
  count?: any
  /** 结束时间戳 13位,精确到毫秒 */
  endTime?: any
  /** 委单类型 0-买单 1-卖单 */
  entrustType?: any
  /** 杠杆模式 nonmag非杠杆，margin杠杆，cross全仓杠杆，isolated逐仓杠杆 */
  marginMode?: any
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
  /** 开始时间戳 13位,精确到毫秒 */
  startTime?: any
  /** 交易对id */
  tradeId?: any
}
export type TGetEntrustTradeFillsResponse = TResponse<
  {
    /** 交易额 */
    amount?: string
    /** 标的币，比如BTC */
    baseCurrency?: string
    /** 数量 */
    count?: string
    /** 创建时间 */
    createTime?: number
    /** 委单ID */
    entrustId?: number
    /** 委单类型 0-买单 1-卖单 */
    entrustType?: number
    /** 手续费 */
    fee?: string
    /** id */
    id?: number
    /** 更新时间 */
    lastupdattime?: number
    /** 成交ID */
    matchId?: number
    /** 撮合类型 0-限价、1-市价、4-计划委托、5跟踪委托 6高级限价、7只做Maker、8全部成交或立即取消、9立即成交并取消剩余 */
    matchType?: number
    /** 价格 */
    prize?: string
    /** 计价币，比如USDT */
    quoteCurrency?: string
    /**  备注 */
    remark?: string
    /** 成交角色 Maker Taker */
    role?: string
    /** 来源 */
    source?: number
    /** 交易区(1-GAVC区 2-BTC区 3-ETH区 4-USDT区 5-创新区 6-ETF交易区 7-USDC区 8-ALTS区 9-BUSD区) */
    tradeArea?: number
    /** 交易ID */
    tradeId?: number
    /** 用户ID */
    uid?: number
  }[]
>
export const getEntrustTradeFills = (params?: TGetEntrustTradeFillsParams, options?: RequestOptions) => {
  return hcAxios.get<TGetEntrustTradeFillsResponse>(API.EntrustTradeFills, { params, options })
}

export type TGetEntrustTradeHistoryParams = {
  /** 是否返回总记录数，默认true */
  count?: any
  /** 结束时间戳 13位,精确到毫秒 */
  endTime?: any
  /** 委单类型 0-买单 1-卖单 */
  entrustType?: any
  /** 杠杆模式 nonmag非杠杆，margin杠杆，cross全仓杠杆，isolated逐仓杠杆 */
  marginMode?: any
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
  /** 标的币(查询条件币种) */
  sellCoinShortName?: any
  /** 开始时间戳 13位,精确到毫秒 */
  startTime?: any
  /** 时间范围(0：自定义时间段，1：一周内，2：一月内，3：三个月内) */
  timeRange?: any
  /** 交易区(1-GAVC区 2-BTC区 3-ETH区 4-USDT区 5-创新区 6-ETF交易区 7-USDC区) */
  tradeArea?: any
  /** 交易对id */
  tradeId?: any
}
export type TGetEntrustTradeHistoryResponse = TResponse<
  {
    /** 交易额 */
    amount?: string
    /** 标的币，比如BTC */
    baseCurrency?: string
    /** 数量 */
    count?: string
    /** 创建时间 */
    createTime?: number
    /** 委单ID */
    entrustId?: number
    /** 委单类型 0-买单 1-卖单 */
    entrustType?: number
    /** 手续费 */
    fee?: string
    /** id */
    id?: number
    /** 更新时间 */
    lastupdattime?: number
    /** 成交ID */
    matchId?: number
    /** 撮合类型 0-限价、1-市价、4-计划委托、5跟踪委托 6高级限价、7只做Maker、8全部成交或立即取消、9立即成交并取消剩余 */
    matchType?: number
    /** 价格 */
    prize?: string
    /** 计价币，比如USDT */
    quoteCurrency?: string
    /**  备注 */
    remark?: string
    /** 成交角色 Maker Taker */
    role?: string
    /** 来源 */
    source?: number
    /** 交易区(1-GAVC区 2-BTC区 3-ETH区 4-USDT区 5-创新区 6-ETF交易区 7-USDC区 8-ALTS区 9-BUSD区) */
    tradeArea?: number
    /** 交易ID */
    tradeId?: number
    /** 用户ID */
    uid?: number
  }[]
>
export const getEntrustTradeHistory = (params?: TGetEntrustTradeHistoryParams, options?: RequestOptions) => {
  return hcAxios.get<TGetEntrustTradeHistoryResponse>(API.EntrustTradeHistory, { params, options })
}

export type TGetEntrustOpenOrdersParams = {
  /** 杠杆模式：nonmag非杠杆，cross全仓杠杆，isolated逐仓杠杆 */
  marginMode?: any

  marginModeList?: any

  statusList?: any
  /** 币对id */
  tradeId?: any

  userId?: any
}
export type TGetEntrustOpenOrdersResponse = TResponse<{
  /** 高级限价订单数量 */
  advancedLimits?: number
  /** 全部类型订单数量 */
  alltys?: number
  /** 限价|市价订单数量 */
  ordinarys?: number
  /** 计划委托订单数量 */
  plans?: number
  /** 跟踪委托订单数量 */
  trailingStops?: number
}>
export const getEntrustOpenOrders = (params?: TGetEntrustOpenOrdersParams, options?: RequestOptions) => {
  return hcAxios.get<TGetEntrustOpenOrdersResponse>(API.EntrustOpenOrders, { params, options })
}

export type TGetTestEntrustPlanOrderPlaceParams = {
  /** 激活价格 */
  activationPrice?: number
  /** 0-买入 1-卖出 */
  direction?: number

  id?: number

  marginAmount?: number
  /** 杠杆模式：nonmag非杠杆，cross全仓杠杆，isolated逐仓杠杆 */
  marginMode?: string
  /** 杠杆订单交易模式：normal普通模式，borrow自动借款，repay自动还款 */
  marginTradeMode?: string
  /** 市价计量单位：amount-数量，funds-金额 */
  marketUnit?: string
  /** 委单类型，默认为4计划委托，5-跟踪委托 */
  matchType?: number
  /** 计划委托价格类型（LIMIT-限价 MARKET-市价 BBO-对手价 optimal5-最优5档 optimal10-最优10档 optimal20-最优20档） */
  priceType?: string
  /** 交易额/交易量 计划委托限价(买入单位-标的币 卖出单位-标的币) 计划委托市价(买入单位-计价币 卖出单位-标的币) */
  tradeAmount?: number
  /** 币对id */
  tradeId?: number
  /** 计划委托价格 */
  tradePrice?: number
  /** 跟踪幅度，比如2%时传2 */
  trailingDelta?: number
  /** 计划委托触发价格 */
  triggerPrice?: number
}
export type TGetTestEntrustPlanOrderPlaceResponse = TResponse<any>
export const getTestEntrustPlanOrderPlace = (
  params?: TGetTestEntrustPlanOrderPlaceParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetTestEntrustPlanOrderPlaceResponse>(API.TestEntrustPlanOrderPlace, { params, options })
}

export type TPostTestEntrustPlanOrderPlaceParams = {
  /** 激活价格 */
  activationPrice?: number
  /** 0-买入 1-卖出 */
  direction?: number

  id?: number

  marginAmount?: number
  /** 杠杆模式：nonmag非杠杆，cross全仓杠杆，isolated逐仓杠杆 */
  marginMode?: string
  /** 杠杆订单交易模式：normal普通模式，borrow自动借款，repay自动还款 */
  marginTradeMode?: string
  /** 市价计量单位：amount-数量，funds-金额 */
  marketUnit?: string
  /** 委单类型，默认为4计划委托，5-跟踪委托 */
  matchType?: number
  /** 计划委托价格类型（LIMIT-限价 MARKET-市价 BBO-对手价 optimal5-最优5档 optimal10-最优10档 optimal20-最优20档） */
  priceType?: string
  /** 交易额/交易量 计划委托限价(买入单位-标的币 卖出单位-标的币) 计划委托市价(买入单位-计价币 卖出单位-标的币) */
  tradeAmount?: number
  /** 币对id */
  tradeId?: number
  /** 计划委托价格 */
  tradePrice?: number
  /** 跟踪幅度，比如2%时传2 */
  trailingDelta?: number
  /** 计划委托触发价格 */
  triggerPrice?: number
}
export type TPostTestEntrustPlanOrderPlaceResponse = TResponse<any>
export const postTestEntrustPlanOrderPlace = (
  params?: TPostTestEntrustPlanOrderPlaceParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostTestEntrustPlanOrderPlaceResponse>(API.TestEntrustPlanOrderPlace, params, { options })
}

export type TGetPublicTradeTipsParams = {
  /** tradeId */
  tradeId?: any
}
export type TGetPublicTradeTipsResponse = TResponse<{
  /** 提示事件 1-下架提示 2-风险提示 */
  tipList?: {
    /** 跳转站内Code */
    supportCode?: string
    /** 提示事件状态 true-是 false-否 */
    tipStatus?: boolean
  }[]
}>
export const getPublicTradeTips = (params?: TGetPublicTradeTipsParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPublicTradeTipsResponse>(API.PublicTradeTips, { params, options })
}

export type TGetSymbolLabelInfoTestParams = any
export type TGetSymbolLabelInfoTestResponse = TResponse<string>
export const getSymbolLabelInfoTest = (params?: TGetSymbolLabelInfoTestParams, options?: RequestOptions) => {
  return hcAxios.get<TGetSymbolLabelInfoTestResponse>(API.SymbolLabelInfoTest, { params, options })
}

export type TGetEntrustListParams = any
export type TGetEntrustListResponse = TResponse<any[]>
export const getEntrustList = (params?: TGetEntrustListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetEntrustListResponse>(API.EntrustList, { params, options })
}

export type TGetEntrustDetailParams = {
  /** 委单ID */
  entrustId?: any
  /** 委托类型（-1-限价|市价、0-限价委托、1-市价委托、4-计划委托、5跟踪委托 6高级限价、7只做Maker、8全部成交或立即取消、9立即成交并取消剩余），新版本必传 */
  matchType?: any
}
export type TGetEntrustDetailResponse = TResponse<any>
export const getEntrustDetail = (params?: TGetEntrustDetailParams, options?: RequestOptions) => {
  return hcAxios.get<TGetEntrustDetailResponse>(API.EntrustDetail, { params, options })
}

export type TGetSymbolListParams = {
  /** 交易区(1-GAVC区 2-BTC区 3-ETH区 4-USDT区 5-创新区 6-ETF交易区 7-USDC区) */
  tradeArea?: any
}
export type TGetSymbolListResponse = TResponse<
  {
    /** 计价币全称(根据用户配置语言展示) */
    buyCoinFullName?: string
    /** buyFee */
    buyFee?: string
    /** 币种名称(右边) */
    buyShortName?: string
    /** buySymbol */
    buySymbol?: string
    /** 有效小数位控制 */
    digit?: string
    /** 当前登录用户是否收藏该币对 */
    favorite?: boolean
    /** 币种Logo */
    imageUrl?: string
    /** 是否显示法币折合，true是 false否 */
    isFiatConvert?: boolean
    /** 是否支持杠杆 */
    isMarginTrade?: boolean
    /** 是否是新币对（开盘72小时以内） */
    isNew?: boolean
    /** 1:表示开盘 0:表示未开盘 */
    isOpen?: string
    /** 是否支持价格订阅 */
    isPriceAlert?: boolean
    /** 是否风险提示(比如24小时跌破开盘价) 1-是 0-否 */
    isRiskTip?: boolean
    /** 是否显示 */
    isShow?: boolean
    /** 标签 */
    label?: string
    /** 标签id */
    labelId?: number
    /** 上市时间戳 */
    listingTime?: number
    /** 最大杠杆倍数 */
    marginRatio?: string
    /** 市值 */
    marketCap?: string
    /** 开盘时间，格式为MM-dd HH:mm */
    openTime?: string
    /** 标的币全称(根据用户配置语言展示) */
    sellCoinFullName?: string
    /** sellFee */
    sellFee?: string
    /** 币种名称(左边) */
    sellShortName?: string
    /** sellSymbol */
    sellSymbol?: string
    /** 交易区(1-GAVC区 2-BTC区 3-ETH区 4-USDT区 5-创新区 6-ETF交易区 7-USDC区) */
    tradeArea?: number
    /** 交易id */
    tradeId?: number
  }[]
>
export const getSymbolList = (params?: TGetSymbolListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetSymbolListResponse>(API.SymbolList, { params, options })
}

export type TGetSymbolLabelInfoParams = {
  /** 交易区(1-GAVC区 2-BTC区 3-ETH区 4-USDT区 5-创新区 6-ETF交易区 7-USDC区) */
  tradeArea?: any
}
export type TGetSymbolLabelInfoResponse = TResponse<{
  /** 币种信息列表 */
  symbolList?: {
    /** 计价币全称(根据用户配置语言展示) */
    buyCoinFullName?: string
    /** buyFee */
    buyFee?: string
    /** 币种名称(右边) */
    buyShortName?: string
    /** buySymbol */
    buySymbol?: string
    /** 有效小数位控制 */
    digit?: string
    /** 当前登录用户是否收藏该币对 */
    favorite?: boolean
    /** 币种Logo */
    imageUrl?: string
    /** 是否显示法币折合，true是 false否 */
    isFiatConvert?: boolean
    /** 是否支持杠杆 */
    isMarginTrade?: boolean
    /** 是否是新币对（开盘72小时以内） */
    isNew?: boolean
    /** 1:表示开盘 0:表示未开盘 */
    isOpen?: string
    /** 是否支持价格订阅 */
    isPriceAlert?: boolean
    /** 是否风险提示(比如24小时跌破开盘价) 1-是 0-否 */
    isRiskTip?: boolean
    /** 是否显示 */
    isShow?: boolean
    /** 标签 */
    label?: string
    /** 标签id */
    labelId?: number
    /** 上市时间戳 */
    listingTime?: number
    /** 最大杠杆倍数 */
    marginRatio?: string
    /** 市值 */
    marketCap?: string
    /** 开盘时间，格式为MM-dd HH:mm */
    openTime?: string
    /** 标的币全称(根据用户配置语言展示) */
    sellCoinFullName?: string
    /** sellFee */
    sellFee?: string
    /** 币种名称(左边) */
    sellShortName?: string
    /** sellSymbol */
    sellSymbol?: string
    /** 交易区(1-GAVC区 2-BTC区 3-ETH区 4-USDT区 5-创新区 6-ETF交易区 7-USDC区) */
    tradeArea?: number
    /** 交易id */
    tradeId?: number
  }[]
  /** 标签信息列表 */
  tradeLabelList?: {
    /** 币种Logo */
    id?: number
    /** 中文标签 */
    labelCn?: string
    /** 英文标签 */
    labelEn?: string
    /** 次序 */
    sort?: number
  }[]
}>
export const getSymbolLabelInfo = (params?: TGetSymbolLabelInfoParams, options?: RequestOptions) => {
  return hcAxios.get<TGetSymbolLabelInfoResponse>(API.SymbolLabelInfo, { params, options })
}

export type TGetTradeLabelListParams = any
export type TGetTradeLabelListResponse = TResponse<
  {
    /** 币种Logo */
    id?: number
    /** 中文标签 */
    labelCn?: string
    /** 英文标签 */
    labelEn?: string
    /** 次序 */
    sort?: number
  }[]
>
export const getTradeLabelList = (params?: TGetTradeLabelListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetTradeLabelListResponse>(API.TradeLabelList, { params, options })
}
